import DataGrid2 from '../../..';

export async function removeRows(this: DataGrid2, keys: any[]) {
	await this.rowChangeAction(
		keys.map(key => ({
			type: 'remove',
			key
		}))
	);
}
